export default {
  DATE_FORMAT: "YYYY.MM.DD hh:mm A",
  MAX_SEARCH_ROW_NUM: 12,
  MAX_SEARCH_ROW_PARTICIPANTS_NUM: 50,
  SORT_OPTIONS: [
    {
      value: "newest-first",
      text: "Newest first",
    },
    {
      value: "newest-last",
      text: "Newest last",
    },
    {
      value: "sort-name",
      text: "Sort by name",
    },
    {
      value: "sort-type",
      text: "Sort by type",
    },
  ],
  VISIBLE_LEVEL: {
    DEFAULT: 0,
    CHANNEL: 1,
    ALL: 2,
  },
};
